var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MetaMask_Fox 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.0312 11.1426L54.8008 34.3378L60.576 20.6529L86.0312 11.1426Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9363 11.1426L44.9156 34.5575L39.4228 20.6529L13.9363 11.1426ZM74.7963 64.9091L66.4787 77.6523L84.2753 82.5487L89.3914 65.1915L74.7963 64.9091ZM10.6406 65.1915L15.7254 82.5487L33.522 77.6523L25.2043 64.9091L10.6406 65.1915Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.5178 43.3774L27.5586 50.8789L45.2297 51.6636L44.6019 32.6743L32.5178 43.3774ZM67.4519 43.3774L55.2108 32.4546L54.8028 51.6636L72.4425 50.8789L67.4519 43.3774ZM33.5222 77.6523L44.1311 72.4734L34.966 65.3171L33.5222 77.6523ZM55.8386 72.4734L66.4789 77.6523L65.0037 65.3171L55.8386 72.4734Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.4801 77.6523L55.8398 72.4734L56.6873 79.41L56.5931 82.329L66.4801 77.6523ZM33.5234 77.6523L43.4104 82.329L43.3477 79.41L44.1324 72.4734L33.5234 77.6523Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.5661 60.7343L34.7148 58.1292L40.9609 55.2729L43.5661 60.7343ZM56.4035 60.7343L59.0086 55.2729L65.2861 58.1292L56.4035 60.7343Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5208 77.6523L35.0274 64.909L25.2031 65.1915L33.5208 77.6523ZM64.9709 64.909L66.4775 77.6523L74.7951 65.1915L64.9709 64.909ZM72.441 50.8789L54.8014 51.6636L56.4335 60.7345L59.0387 55.2731L65.3161 58.1294L72.441 50.8789ZM34.7135 58.1294L40.9909 55.2731L43.5647 60.7345L45.2282 51.6636L27.5572 50.8789L34.7135 58.1294Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.5586 50.8789L34.966 65.3171L34.7149 58.1294L27.5586 50.8789ZM65.3175 58.1294L65.0037 65.3171L72.4425 50.8789L65.3175 58.1294ZM45.2297 51.6636L43.5661 60.7345L45.6377 71.4376L46.1085 57.3447L45.2297 51.6636ZM54.8028 51.6636L53.9553 57.3133L54.332 71.4376L56.4349 60.7345L54.8028 51.6636Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M56.4349 60.7345L54.3319 71.4376L55.8385 72.4734L65.0036 65.3171L65.3175 58.1294L56.4349 60.7345ZM34.7148 58.1294L34.9659 65.3171L44.131 72.4734L45.6376 71.4376L43.5661 60.7345L34.7148 58.1294Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M56.5931 82.3291L56.6873 79.41L55.9026 78.7195H44.0696L43.3477 79.41L43.4104 82.3291L33.5234 77.6523L36.976 80.4772L43.9754 85.3422H55.9968L63.0275 80.4772L66.4801 77.6523L56.5931 82.3291Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M55.8398 72.4733L54.3332 71.4375H45.6389L44.1323 72.4733L43.3477 79.4099L44.0696 78.7194H55.9026L56.6873 79.4099L55.8398 72.4733Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M87.3502 35.8444L90.0181 23.0384L86.0319 11.1426L55.8373 33.5531L67.4506 43.3774L83.8662 48.1796L87.5071 43.9423L85.9378 42.8124L88.4488 40.5211L86.5028 39.0145L89.0137 37.0999L87.3502 35.8444ZM9.98047 23.0384L12.6484 35.8444L10.9535 37.0999L13.4645 39.0145L11.5498 40.5211L14.0608 42.8124L12.4915 43.9423L16.101 48.1796L32.5166 43.3774L44.1299 33.5531L13.9353 11.1426L9.98047 23.0384Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M83.8672 48.1795L67.4517 43.3773L72.4422 50.8788L65.0035 65.317L74.7963 65.1914H89.3914L83.8672 48.1795ZM32.5176 43.3773L16.102 48.1795L10.6406 65.1914H25.2043L34.9658 65.317L27.5584 50.8788L32.5176 43.3773ZM54.8026 51.6635L55.8384 33.553L60.6092 20.6528H39.4228L44.1309 33.553L45.2295 51.6635L45.6061 57.376L45.6375 71.4375H54.3318L54.3945 57.376L54.8026 51.6635Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.5e69fe98f1dc1b94e06a1bf51cc2d1a3.svg";
export { ForwardRef as ReactComponent };